import { type AiBuilderMessage } from '../store';
import { AiBuilderAssistantMarkdownContent } from './AiBuilderAssistantMarkdownContent';
import { AiBuilderChatMessageAI } from './AiBuilderChatMessageAI';
export const AiBuilderSystemMessage = ({
  message
}: {
  message: Extract<AiBuilderMessage, {
    kind: 'system';
  }>;
}) => <AiBuilderChatMessageAI tone={message.tone === 'error' ? 'error' : undefined} data-sentry-element="AiBuilderChatMessageAI" data-sentry-component="AiBuilderSystemMessage" data-sentry-source-file="AiBuilderSystemMessage.tsx">
    <AiBuilderChatMessageAI.Body data-sentry-element="unknown" data-sentry-source-file="AiBuilderSystemMessage.tsx">
      <AiBuilderAssistantMarkdownContent content={message.content} data-sentry-element="AiBuilderAssistantMarkdownContent" data-sentry-source-file="AiBuilderSystemMessage.tsx" />
    </AiBuilderChatMessageAI.Body>
    <AiBuilderChatMessageAI.Copy text={message.content} data-sentry-element="unknown" data-sentry-source-file="AiBuilderSystemMessage.tsx" />
  </AiBuilderChatMessageAI>;